import script from "./Customers.vue?vue&type=script&setup=true&lang=js"
export * from "./Customers.vue?vue&type=script&setup=true&lang=js"

import "./Customers.vue?vue&type=style&index=0&id=3dbff83e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dbff83e"]])

export default __exports__